import {darken} from 'polished';

import {newPalette, NewPaletteColorsEnum} from '../../../libs/shared/ui/src/styles/colorStyles';
import {ProgressSerie} from '../components/charts/components/progressBar/progressBarSerie';

export const makeDefaultProgressBarSeries = (value: number, isInverted?: boolean): Array<ProgressSerie> => [
  {
    value: isInverted ? Math.round(100 - value * 100) : Math.round(value * 100),
    color: newPalette[NewPaletteColorsEnum.BLUE].highlight,
    hoverColor: darken(0.02, newPalette[NewPaletteColorsEnum.BLUE].highlight),
  },
  {
    value: isInverted ? Math.round(value * 100) : Math.round(100 - value * 100),
    color: newPalette[NewPaletteColorsEnum.BLUE].lowlight,
    hoverColor: darken(0.02, newPalette[NewPaletteColorsEnum.BLUE].lowlight),
  },
];
